import React from 'react';
import { Image, Select, Input } from 'antd';
import { searchableSelect } from '../../../../utils/selectSearch';
import { Camera, Search, SlidersHorizontal, CircleCheck, CircleX, ImageOff } from 'lucide-react';
import dayjs from 'dayjs';
import { StatusTag, EmptyState, CollapsibleCard } from '../../../common';
import { useContractImageGallery } from './contractDetail.controller';

const { Option } = Select;

function ContractImageGallery({ contract, contractChecks }) {
    const { allImages, filteredImages, uniqueStores, filterStore, setFilterStore, searchTerm, setSearchTerm } = useContractImageGallery({
        contract,
        contractChecks
    });

    return (
        <CollapsibleCard
            title="Galería de Imágenes"
            icon={<Camera />}
            iconTone="success"
            defaultExpanded={false}
            badges={<StatusTag tone="neutral">{allImages.length} imágenes</StatusTag>}>
            {/* Filters */}
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center mb-5">
                <span className="flex items-center gap-1.5 text-[13px] font-medium text-surface-500">
                    <SlidersHorizontal className="text-[15px]" />
                    Filtros
                </span>
                <Select
                    value={filterStore}
                    onChange={setFilterStore}
                    className="w-full sm:w-64"
                    placeholder="Todos los pisos"
                    {...searchableSelect}
                    popupMatchSelectWidth={false}
                    dropdownStyle={{ minWidth: 280 }}>
                    <Option value="all">Todos los pisos ({uniqueStores.length})</Option>
                    {uniqueStores.map((store) => (
                        <Option key={store.id} value={store.id}>
                            {store.name}
                        </Option>
                    ))}
                </Select>
                <Input
                    placeholder="Buscar por piso o cliente..."
                    allowClear
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    prefix={<Search className="text-surface-400" />}
                    className="w-full sm:max-w-[300px]"
                />
                {/* Results Count */}
                {filteredImages.length !== allImages.length && (
                    <span className="text-[13px] text-surface-500 sm:ml-auto tabular-nums">
                        Mostrando {filteredImages.length} de {allImages.length} imágenes
                    </span>
                )}
            </div>

            {/* Image Grid */}
            {filteredImages.length === 0 ? (
                <EmptyState icon={<ImageOff />} title="Sin imágenes" description="No se encontraron imágenes con los filtros seleccionados" />
            ) : (
                <Image.PreviewGroup>
                    <div className="grid gap-4 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
                        {filteredImages.map((img) => (
                            <div key={img.key} className="min-w-0">
                                <div className="relative overflow-hidden rounded-lg border border-surface-200 bg-surface-50">
                                    <Image src={img.url} alt={`${img.storeName}`} width="100%" height={140} className="object-cover" rootClassName="block" />

                                    {/* Availability badge */}
                                    <div className="absolute top-2 right-2 pointer-events-none">
                                        <StatusTag tone={img.available ? 'success' : 'danger'} icon={img.available ? <CircleCheck /> : <CircleX />}>
                                            {img.available ? 'Sí' : 'No'}
                                        </StatusTag>
                                    </div>
                                </div>

                                {/* Store name footer */}
                                <div className="mt-2 min-w-0">
                                    <div className="text-xs font-medium text-surface-800 truncate" title={img.storeName}>
                                        {img.storeName}
                                    </div>
                                    <div className="text-xs text-surface-500 tabular-nums" title={dayjs(img.date).format('DD/MM/YY')}>
                                        {dayjs(img.date).format('DD/MM/YY')}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Image.PreviewGroup>
            )}
        </CollapsibleCard>
    );
}

export default ContractImageGallery;
